import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';

const Home = () => {

  return (
    <>
      <title>MergeURL - Merge and Shorten Multiple URLs into a Single URL</title>
      <Hero imageFill className="illustration-section-01" />
      <FeaturesSplit invertMobile topDivider bottomDivider imageFill className="illustration-section-02" />
      <FeaturesTiles bottomDivider />
    </>
  );
}

export default Home;
